import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const IntroText = styled.p`
  font-family: ${barnesTheme.fonts.body};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  line-height: 1.6;
  text-align: justify;
  margin: 0;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.6 !important;
    text-align: justify !important;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeparatorLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin: ${barnesTheme.spacing.contentGap} 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: ${barnesTheme.spacing.sectionGap};
  flex: 1;

  @media print {
    display: flex !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
    flex: 1 !important;
  }
`

export const LeftColumn = styled.div`
  flex: 1;

  @media print {
    flex: 1 !important;
  }
`

export const StatementText = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.large};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  line-height: 1.5;
  margin-bottom: ${barnesTheme.spacing.contentGap};
  text-transform: uppercase;
  letter-spacing: 0.3px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.large} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.5 !important;
    margin-bottom: ${barnesTheme.spacing.contentGap} !important;
    text-transform: uppercase !important;
    letter-spacing: 0.3px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HighlightBold = styled.span`
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};

  @media print {
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
  }
`

export const CardRedBar = styled.div`
  width: 30px;
  height: 3px;
  background: ${barnesTheme.colors.accent};
  margin: ${barnesTheme.spacing.contentGap} 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    width: 30px !important;
    height: 3px !important;
    background: ${barnesTheme.colors.accent} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 ${barnesTheme.spacing.smallGap}
      0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BulletList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const BulletItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  @media print {
    display: flex !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }
`

export const DashPrefix = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  flex-shrink: 0;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BulletText = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  line-height: 1.5;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.5 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.contentGap};

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const ValueItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const ValueIconCircle = styled.div`
  width: 36px;
  height: 36px;
  border: 1px solid ${barnesTheme.colors.border};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }

  @media print {
    width: 36px !important;
    height: 36px !important;
    border: 1px solid ${barnesTheme.colors.border} !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    svg {
      width: 18px !important;
      height: 18px !important;
    }
  }
`

export const ValueTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const ValueTitle = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.text};
  letter-spacing: 0.3px;
  white-space: pre-line;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.text} !important;
    letter-spacing: 0.3px !important;
    white-space: pre-line !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ValueEnglish = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 10px;
  font-style: italic;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  text-transform: uppercase;
  margin-top: 2px;
  white-space: pre-line;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 10px !important;
    font-style: italic !important;
    text-transform: uppercase !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    white-space: pre-line !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
